import request from '@/utils/request'

// 新增网站访问记录
export function addWeblog(data) {
    return request({
      url: '/web/log',
      method: 'post',
      data: data
    })
  }